
    import {Component, Vue} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {inspectionOrderApi} from "@/api/inspection";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import {userApi} from "@/api/organization";
    import InstrumentList from "@/components/InstrumentList.vue";
    import InstrumentSubmit from "@/components/InstrumentSubmit.vue";
    import ImportPreview from "@/components/ImportPreview.vue";

    @Component({
        name: "inspectionList",
        components: {ImportPreview, SetTableColumns, InstrumentList, InstrumentSubmit}
    })
    export default class Home extends Vue {
        importPreviewDialog = false;
        title = "检定申请列表";
        listData = [];
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        listTotal0 = "";
        modeType = "0";
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        showForm = false;
        form = {
            orderApplyNumber: "",//检定申请编号
            agentName: "", //待办人
            agentMobile: "", //待办人电话
            agentMechanismName: "", //待办人单位名称
            checkStatus: "",  //订单状态
        } as any
        tableKey = 0;
        allSelected = [];
        userData = {} as any;

        created() {
            this.userData = this.$store.state.AuthedUser;
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if(q.modeType){
                this.modeType = q.modeType;
            }
            if(q.size){
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            this.getConfig();
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.list("0");
                if(this.modeType == "1"){
                    this.list("1");
                }
            }
            this.tableClearSelect();
            if(this.modeType == "3"){
                const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
                $instrumentList.list();
            }
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        getConfig() {
            userApi.getUserConfig({name: "inspectionPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.list("0");
                    if(this.modeType == "1"){
                        this.list("1");
                    }
                }
            })
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }
        handleClick() {
            const instrumentSubmit = this.$refs.instrumentSubmit as HTMLFormElement;
            if(instrumentSubmit){
                instrumentSubmit.reset();
            }
            this.tableClearSelect();
            this.refresh();
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        reset(){
            for(const f in this.form){
                this.form[f] = "";
            }
            this.refresh();
        }
        refresh(){
            this.listParam.current = 1;
            this.list();
        }
        list(modeType: string = this.modeType) {
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q,{modeType: this.modeType}, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            // if(JSON.stringify(q) != JSON.stringify(route.query)){
            //     this.$router.replace({name:route.name!,query: q})
            // }



            const params = {
                ...this.listParam,
                ...this.form,
                submitType: modeType?modeType:this.modeType,
            }
            let api = null;
            if(params.submitType == 1){
                api = inspectionOrderApi.listInspectionOrderApply({...params, mode:1, modeType: 2});
            }else{
                api = inspectionOrderApi.list(params);
            }
            api.then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    if(this.modeType == modeType){
                        this.listData = rData.records;
                        this.listTotal = rData.total;
                    }
                    if(modeType == "0"){
                        this.listTotal0 = rData.total;
                    }
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: "inspectionPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        add() {
            this.$router.push("/qj/inspection/edit/0/0/0");
        }
        //1办理 2查看
        rightBtn(type: number) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if (type !== 0) {
                if (dataArr.length == 0) {
                    this.$message.error("请先勾选");
                    return;
                }
                if (dataArr.length > 1 && (type == 1 || type == 2 || type == 3)) {
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
                if(type == 1) {
                    this.toEdit({id: id});
                }else if(type == 2){
                    this.toDetail(dataArr[0]);
                }else if(type == 3){
                    this.recallBack(id);
                }
            }
        }

        recallBack(id: number) {
            this.$confirm("确认要退回到待提交状态吗?", "确认操作", {type: "warning"})
                .then(() => {
                    inspectionOrderApi.returnInspectionOrderApply({ids: id, modeType: 1}).then(r => {
                        if (r.data.result === 0) {
                            this.$message("退回成功");
                            this.handleClick();
                        }
                    })
                })
        }
        //跳转详情
        toDetail(row: any){
            let orderId = 0;
            let orderApplyId = 0;
            if(this.modeType == '1'){
                orderId = row.orderId;
                orderApplyId = row.id;
            }else{
                orderId = row.id;
            }
            if(this.modeType == '1'){
                this.$router.push("/qj/inspection/edit/"+row.id+"/2/"+orderId);
            }else{
                this.$router.push("/qj/inspection/detail/" + orderId + "/" + orderApplyId );
            }
        }
        //跳转编辑
        toEdit(row: any){
            this.$router.push("/qj/inspection/edit/"+row.id+"/1/0");
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }

        //新增器具列表*********************************
        instrumentParam(data: any){
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, data);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            // if(JSON.stringify(q) != JSON.stringify(route.query)){
            //   this.$router.replace({name:route.name!,query: q})
            // }
            if(q.size){
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
        }
        //获取器具的勾选 1办理  2查看
        instrumentExamineChange = false;
        instrumentCheck(type: number){
            const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
            const dataArr = $instrumentList.getCheckData();
            if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return;
            }
            if (dataArr.length > 1 ) {
                this.$message.error("只能勾选一条");
                return;
            }
            if(type == 1){
                // $instrumentList.checkAdd(dataArr[0].instrumentId);
                $instrumentList.showExamineList(dataArr[0], true);
                this.instrumentExamineChange = true;
            }else{
                // $instrumentList.detail(dataArr[0]);
                $instrumentList.showExamineList(dataArr[0], true);
                this.instrumentExamineChange = false;
            }
        }
        //新增器具列表end*********************************

        //  批量导出器具 导入结果****************************************
        importPreviewData = [];
        importPreviewShowType = 0;  //0导出  1导入
        batchExport(){
            const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
            const dataArr = $instrumentList.getCheckData();
            if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return;
            }
            this.importPreviewData = dataArr;
            this.importPreviewShowType = 0;
            this.importPreviewDialog = true;
        }
        batchImport(){
            console.log("批量导入");
            this.importPreviewShowType = 1;
            this.importPreviewDialog = true;
        }
        clostDialog(){
            this.importPreviewDialog = false;
            if(this.modeType == "2"){
                const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
                $instrumentList.list();
            }
        }
        dialogForm = {} as any; //器具列表搜索条件
        refreshInstrument(e:any) {
            this.dialogForm = JSON.parse(JSON.stringify(e));
        }
        //  批量导出器具 导入结果 end****************************************
    }
